import React from 'react'
import { useTranslation } from 'react-i18next'
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline'
import RadioWaveRings from '../Elements/RadioWaveRings'

const modulosData = [
  { key: 'entradas', number: '01' },
  { key: 'salidas', number: '02' },
  { key: 'rastreo', number: '03' },
  { key: 'acomodoTienda', number: '04' },
  { key: 'auditorias', number: '05' },
  { key: 'produccion', number: '06' },
  { key: 'puntoVenta', number: '07' },
  { key: 'aMedida', number: '+', highlighted: true },
]

export default function SWRYApage() {
  const { t } = useTranslation('swrya')

  return (
    <div>
      {/* Hero section — app window a pantalla completa */}
      <div className="bg-navy-950 pt-14">
        <div className="mx-auto max-w-3xl px-6 pb-16 pt-24 text-center sm:pt-32 lg:px-8">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-medium text-neon-300">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-neon-300 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-neon-300"></span>
            </span>
            {t('hero.badge')}
          </span>
          <h1 className="mt-6 text-4xl font-bold tracking-tight text-white sm:text-6xl">
            {t('hero.title.prefix')} <span className="text-neon-300">{t('hero.title.highlight')}</span>
          </h1>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-white/70">
            {t('hero.description')}
          </p>
          <div className="mt-10 flex items-center justify-center gap-4">
            <a
              href="https://swrya.io/"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-md bg-neon-300 px-5 py-3 text-sm font-semibold text-navy-900 shadow-sm transition hover:bg-neon-400 sm:text-base"
            >
              {t('hero.cta')} <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>

        <div className="mx-auto hidden max-w-6xl px-6 pb-24 lg:block lg:px-8">
          <div className="overflow-hidden rounded-xl border border-white/10 shadow-2xl">
            <div className="flex items-center gap-1.5 border-b border-white/10 bg-white/5 px-4 py-3">
              <span className="h-3 w-3 rounded-full bg-white/20"></span>
              <span className="h-3 w-3 rounded-full bg-white/20"></span>
              <span className="h-3 w-3 rounded-full bg-white/20"></span>
            </div>
            <img src="/swrya.jpeg" alt={t('hero.imageAlt')} className="h-[28rem] w-full object-cover object-top" />
          </div>
        </div>
      </div>

      {/* Cada bloque es texto (scrollable) a la izquierda + visual sticky a la derecha */}
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        {/* MÓDULOS */}
        <div className="grid grid-cols-1 items-start gap-12 border-t border-gray-100 py-24 first:border-t-0 lg:grid-cols-2 sm:py-32">
          <div>
            <h2 className="text-base font-semibold leading-7 text-electric-600">{t('modulos.eyebrow')}</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              {t('modulos.title')}
            </p>
            <div className="mt-10 space-y-6">
              {modulosData.map((modulo) => (
                <div
                  key={modulo.key}
                  className={`border-l-2 pl-4 ${modulo.highlighted ? 'border-neon-400' : 'border-gray-200'}`}
                >
                  <span className={`text-xs font-bold ${modulo.highlighted ? 'text-neon-600' : 'text-electric-600'}`}>{modulo.number}</span>
                  <h3 className="text-base font-bold text-navy-900">{t(`modulos.items.${modulo.key}.title`)}</h3>
                  <p className="mt-1 text-sm leading-6 text-gray-600">{t(`modulos.items.${modulo.key}.description`)}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:sticky lg:top-24">
            <div className="overflow-hidden rounded-2xl border border-gray-200 bg-gray-50 p-6">
              <img src="/sw.png" alt={t('modulos.imageAlt')} className="h-96 w-full rounded-xl object-contain" />
            </div>
          </div>
        </div>

        {/* WMS PARA PYMES */}
        <div className="grid grid-cols-1 items-start gap-12 border-t border-gray-100 py-24 lg:grid-cols-2 sm:py-32">
          <div>
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy-900">
              <BuildingStorefrontIcon className="h-5 w-5 text-white" aria-hidden="true" />
            </div>
            <h2 className="mt-4 text-base font-semibold leading-7 text-electric-600">{t('pymes.eyebrow')}</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              {t('pymes.title')}
            </p>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              {t('pymes.description')}
            </p>
            <ul className="mt-8 space-y-3 text-sm leading-6 text-gray-600">
              {t('pymes.bullets', { returnObjects: true }).map((bullet) => (
                <li key={bullet} className="flex gap-2">
                  <span className="text-electric-500">&bull;</span>
                  {bullet}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:sticky lg:top-24">
            <div className="overflow-hidden rounded-2xl">
              <img src="/wmswrya.png" alt={t('pymes.imageAlt')} className="w-full rounded-xl object-contain" />
            </div>
          </div>
        </div>

      </div>

      {/* CIERRE */}
      <div className="mx-auto max-w-7xl px-6 pt-24 pb-24 sm:pt-32 sm:pb-32 lg:px-8">
        <div className="overflow-hidden rounded-3xl shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative isolate flex flex-col justify-center overflow-hidden bg-gradient-to-br from-navy-950 via-navy-900 to-electric-700 px-6 py-16 sm:px-12 sm:py-20 lg:px-16">
              <div
                className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-neon-300/20 blur-3xl"
                aria-hidden="true"
              />
              <div
                className="pointer-events-none absolute -bottom-24 -left-10 h-64 w-64 rounded-full bg-electric-400/20 blur-3xl"
                aria-hidden="true"
              />
              <div className="relative">
                <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-medium text-neon-300">
                  <span className="relative flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-neon-300 opacity-75"></span>
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-neon-300"></span>
                  </span>
                  {t('cierre.badge')}
                </span>
                <p className="mt-6 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                  {t('cierre.title')}
                </p>
                <p className="mt-6 max-w-md text-lg leading-8 text-white/70">
                  {t('cierre.description')}
                </p>
                <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                  <a
                    href="https://swrya.io/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex w-full items-center justify-center rounded-md bg-neon-300 px-6 py-3.5 text-base font-semibold text-navy-900 shadow-sm transition hover:bg-neon-400 lg:inline-flex lg:w-auto"
                  >
                    {t('cierre.cta')} <span aria-hidden="true" className="ml-1">&rarr;</span>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="relative isolate hidden min-h-[24rem] overflow-hidden bg-navy-950 lg:block lg:min-h-0"
              style={{
                backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.08) 1px, transparent 1px)',
                backgroundSize: '28px 28px',
              }}
            >
              <img
                src="/swrya_logo_negro.svg"
                alt=""
                aria-hidden="true"
                className="absolute left-1/2 top-1/2 h-56 w-56 -translate-x-1/2 -translate-y-1/2 opacity-[0.07] invert"
              />

              <div className="absolute inset-0 flex items-center justify-center">
                <RadioWaveRings
                  sizes={['h-20 w-20', 'h-40 w-40', 'h-64 w-64', 'h-96 w-96']}
                  ringColorClasses={['border-neon-300/60', 'border-neon-300/35', 'border-neon-300/18', 'border-neon-300/8']}
                />
                <span className="relative h-3 w-3 rounded-full bg-neon-300 shadow-[0_0_24px_6px_rgba(212,255,63,0.55)]"></span>
              </div>

              <div className="absolute left-[58%] top-[28%] w-56 animate-card-reveal rounded-lg bg-white p-4 shadow-xl sm:w-64">
                <div className="flex items-center gap-2">
                  <img src="/swrya_logo_negro.svg" alt="" aria-hidden="true" className="h-4 w-4 shrink-0" />
                  <p className="text-sm font-bold text-navy-900">{t('cierre.card.title')}</p>
                </div>
                <p className="mt-1 text-xs text-electric-600">{t('cierre.card.subtitle')}</p>
                <div className="my-2 h-px bg-gray-100"></div>
                <p className="text-xs leading-5 text-gray-500">{t('cierre.card.footer')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
